const { atom } = require("recoil");
export const selectedFilterState = atom({
  key: "selectedFilterState",
  default: {},
});
export const formDataFilterState = atom({
  key: "formDataFilterState",
  default: {},
});
export const updatedVariableState = atom({
  key: "updatedVariableState",
  default: {},
});

export const targetFilterState = atom({
  key: "targetFilterState",
  default: "Assigned",
});
